module.exports = __webpack_public_path__ + "img/json-file.f193fbe2.svg";